import { MenuItem as BaseMenuItem, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const MenuItem = styled(BaseMenuItem)``;

export const ItemWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${(p) => p.theme.palette.grey[700]};
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(0.5)};
`;
